
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.4 11.2c-.626 0-1.127.042-1.555.105C5.08 11.563 3.6 13.358 3.6 15.2a.8.8 0 11-1.6 0c0-2.074 1.3-4.112 3.167-5.027a5.6 5.6 0 116.465 0c1.868.915 3.168 2.953 3.168 5.027a.8.8 0 11-1.6 0c0-1.842-1.48-3.637-3.245-3.895A10.61 10.61 0 008.4 11.2zm0-1.6a4 4 0 110-8 4 4 0 010 8z"}})])
          )
        }
      }
    